import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ModalRef, MODAL_DATA_VAR } from "mis-design-system/mis-modal";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { EmpUserService } from "../../../services/emp-user.service";

@Component({
  selector: "mis-employee-web-exp-vaccination-eligibility",
  templateUrl: "./vaccination-eligibility.component.html",
  styleUrls: ["./vaccination-eligibility.component.scss"]
})
export class VaccinationEligibilityComponent implements OnInit {
  constructor(private router: Router, private user: EmpUserService, @Inject(MODAL_DATA_VAR) data, private modalRef: ModalRef) {
    this.eligibility = data?.["eligibility"];
    this.status = { ...data?.["status"], vaxStatus: data?.["status"]?.["vaxStatus"]?.toLowerCase() };
  }
  eligibility: NsEmpWebExpData.IEligibilityInfo;
  status: NsEmpWebExpData.IVaXStatus;
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  ngOnInit(): void {}

  close() {
    this.modalRef.close();
  }

  handleVaccineUpdate() {
    this.close();
    this.router.navigate(["/" + this.user.environment.navLinks.vaccinationUpload], {
      queryParamsHandling: "preserve"
    });
  }
}
